/**
 *
 *
 * @param name
 * @param type
 * @param content
 * @param roles
 * @returns {Promise<void>}
 */
import {apiDELETE, apiGET, apiGETPaginated, apiPOST, apiPUT} from "./RequestsCore";

/**
 * Returns all the existing attorneysa according to provided filters, with pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getAttorneysPaginated(filters) {
    return await apiGETPaginated('/api/attorneys', filters);
}

/**
 * Returns all the existing attorneys without pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getAttorneys() {
    return await apiGET('/api/attorneys');
}

/**
 * Creates a new attorney with the provided data.
 *
 * @param attorney
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function createAttorney(attorney) {
    return await apiPOST('/api/attorney', attorney);
}

/**
 * Updates the provided attorney with the provided data.
 *
 * @param attorney
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function editAttorney(attorney) {
    return await apiPUT('/api/attorney/' + attorney.id, attorney);
}

/**
 * Deletes the provided attorney
 *
 * @param attorney
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function deleteAttorney(attorney) {
    return await apiDELETE('/api/attorney/' + attorney.id);
}